import React, { useState } from "react";
import "./NPSModal.css";
import { apiPost } from '../../utils/api';
import { configShop } from '../../states/configShop';

const RATINGS = [
    { emoji: "😞", label: "Muy mala",   score: 2,  color: "#FF4C4C" },
    { emoji: "😕", label: "Mala",        score: 4,  color: "#FF8C42" },
    { emoji: "😐", label: "Regular",     score: 6,  color: "#F5C518" },
    { emoji: "😊", label: "Buena",       score: 8,  color: "#4CAF50" },
    { emoji: "🤩", label: "¡Excelente!", score: 10, color: "#6C63FF" },
];

const NPSModal = ({ open, onClose, onSubmit, orderId }) => {
    const { dataConfig } = configShop();
    const [selected, setSelected] = useState(null);
    const [comment, setComment] = useState('');
    const [step, setStep] = useState('rate'); // 'rate' | 'thanks'
    const [sending, setSending] = useState(false);

    const brandColor = dataConfig?.color_botton;
    const brandText = dataConfig?.color_button_text;

    const activeRating = selected !== null ? RATINGS[selected] : null;

    const handleSend = async () => {
        if (selected === null) return;
        setSending(true);
        try {
            await apiPost('/nps', {
                score: RATINGS[selected].score,
                channel: "web-app",
                comment: comment.trim(),
                order_id: orderId,
            });
        } catch (err) {
            console.log(err);
        } finally {
            setSending(false);
            setStep('thanks');
        }
    };

    const handleClose = () => {
        setSelected(null);
        setComment('');
        setStep('rate');
        onClose();
    };

    if (!open) return null;

    return (
        <div className="nps-overlay" onClick={handleClose}>
            <div className="nps-sheet" onClick={(e) => e.stopPropagation()}>
                <div className="nps-handle" />

                {step === 'rate' ? (
                    <>
                        {/* Header */}
                        <div className="nps-header">
                            <span className="nps-wave">👋</span>
                            <h2 className="nps-title">¿Cómo estuvo tu pedido?</h2>
                            <p className="nps-subtitle">
                                Tu opinión nos ayuda a mejorar cada día.
                                ¡Solo toma 10 segundos!
                            </p>
                        </div>

                        {/* Emojis */}
                        <div className="nps-emojis">
                            {RATINGS.map((r, i) => (
                                <button
                                    key={i}
                                    className={`nps-emoji-btn ${selected === i ? "nps-emoji-btn--active" : ""} ${selected !== null && selected !== i ? "nps-emoji-btn--dim" : ""}`}
                                    onClick={() => setSelected(i)}
                                    style={selected === i ? { "--emoji-color": r.color } : {}}
                                    aria-label={r.label}
                                >
                                    <span className="nps-emoji">{r.emoji}</span>
                                </button>
                            ))}
                        </div>

                        {/* Label dinámico */}
                        <div className="nps-label-wrap">
                            {activeRating ? (
                                <span
                                    className="nps-label-active"
                                    style={{ color: activeRating.color }}
                                >
                                    {activeRating.label}
                                </span>
                            ) : (
                                <span className="nps-label-hint">
                                    Toca un emoji para calificar
                                </span>
                            )}
                        </div>

                        {/* Comentario (aparece al seleccionar) */}
                        {selected !== null && (
                            <div className="nps-comment-wrap">
                                <label className="nps-comment-label">
                                    {RATINGS[selected].score >= 8
                                        ? "¿Qué fue lo que más te gustó? (opcional)"
                                        : "¿Qué podríamos mejorar? (opcional)"}
                                </label>
                                <textarea
                                    className="nps-comment"
                                    placeholder="Cuéntanos más..."
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    rows={3}
                                    style={{ "--focus-color": brandColor || "#6C63FF" }}
                                />
                            </div>
                        )}

                        {/* Botones */}
                        <div className="nps-actions">
                            <button className="nps-skip" onClick={handleClose}>
                                Ahora no
                            </button>
                            <button
                                className="nps-send"
                                onClick={handleSend}
                                disabled={selected === null || sending}
                                style={{ "--btn-color": brandColor || activeRating?.color || "#6C63FF", "--btn-text": brandText || "#fff" }}
                            >
                                {sending ? <span className="nps-spinner" /> : "Enviar opinión"}
                            </button>
                        </div>
                    </>
                ) : (
                    /* Pantalla de gracias */
                    <div className="nps-thanks">
                        <div className="nps-thanks-emoji">
                            {RATINGS[selected].score >= 8 ? "🎉" : "🙏"}
                        </div>
                        <h2 className="nps-thanks-title">
                            {RATINGS[selected].score >= 8
                                ? "¡Nos alegra mucho!"
                                : "¡Gracias por tu honestidad!"}
                        </h2>
                        <p className="nps-thanks-sub">
                            {RATINGS[selected].score >= 8
                                ? "Tu calificación nos motiva a seguir dando lo mejor. ¡Hasta pronto! 🚀"
                                : "Usaremos tu opinión para mejorar tu próxima experiencia. ¡Prometido! 💪"}
                        </p>
                        <button
                            className="nps-send nps-send--full"
                            onClick={handleClose}
                            style={{ "--btn-color": brandColor || "#6C63FF", "--btn-text": brandText || "#fff" }}
                        >
                            Cerrar
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NPSModal;
